import type { FieldMergeFunction, TypePolicies } from '@apollo/client';

import { relayStylePagination } from '@apollo/client/utilities';

const simpleMerge: FieldMergeFunction = (existing, incoming) => ({
  ...existing,
  ...incoming,
});

const overwriteMerge: FieldMergeFunction = (_, incoming) => incoming;

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      filesForOwner: { merge: simpleMerge },
      newsArticleConnection: relayStylePagination(),
    },
  },

  GroupMembershipMemberTypeDetail: {
    keyFields: ['details', ['_id']],
  },

  GroupAvailableMemberType: {
    keyFields: ['memberDetailsType', ['_id']],
  },

  GroupPrivacyDataFeaturePermission: {
    keyFields: false,
  },

  GroupCompletePrivacyDataFeaturePermission: {
    keyFields: false,
  },

  GroupMembership: {
    fields: {
      membersConnection: relayStylePagination(),
    },
  },

  Group: {
    fields: {
      membershipData: { merge: simpleMerge },
      constitution: { merge: simpleMerge },
      candidateMember: { merge: simpleMerge },
      effectiveness: { merge: simpleMerge },
      groupMemberHistoricalRecordsConnection: relayStylePagination(),
      postsConnection: relayStylePagination(['@connection', 'key']),
      postsSearchConnection: relayStylePagination(),
      getTrainingCoursesByTagsConnection: relayStylePagination(),
      getTrainingSessionsByTrainerConnection: relayStylePagination(),
    },
  },
  ServiceUsageMetrics: {
    keyFields: false,
  },
  Service: {
    fields: {
      serviceUsageMetrics: {
        keyArgs: ['first', 'offset'],
      },
      newsArticleConnection: relayStylePagination(),
      serviceGroupsConnection: relayStylePagination([
        'searchTerm',
        'includeAdminGroups',
        'first',
      ]),
      serviceInterestDeclarationsGroupsConnection: relayStylePagination([
        'filterBy',
        ['name'],
      ]),
      serviceResourcesSearchConnection: relayStylePagination(),
      confirmationGroupsConnection: relayStylePagination([
        'serviceId',
        'globalConfirmationId',
        'serviceConfirmationId',
        'filterBy',
        ['name'],
      ]),
      groupPostsConnection: relayStylePagination(['@connection', 'key']),
      searchSubscribers: relayStylePagination(),
    },
  },
  ServiceTrainingBookingSearchResult: {
    fields: {
      faceToFaceTrainingCoursesConnection: relayStylePagination(),
      onlineTrainingCoursesConnection: relayStylePagination(),
      trainingSessionsConnection: relayStylePagination(),
    },
  },
  GenericTrainingCourse: {
    fields: {
      hasAvailableSession: {
        keyArgs: false,
      },
    },
  },
  User: {
    fields: {
      shortcutGroupsAndServicesConnection: relayStylePagination([
        'filterBy',
        ['name'],
      ]),
      shortcuts: { merge: false }, // always use the new shortcuts that come through
      trainingRecords: { merge: false }, // prefer incoming data as we have no paging here
      groupPostsConnection: relayStylePagination(['@connection', 'key']),
      pinnedDashboardPostsConnection: relayStylePagination([
        '@connection',
        'key',
      ]),
      userSearch: relayStylePagination(['search']),
      memberOfGroupsConnection: relayStylePagination(),
      ortooGptConversationConnection: relayStylePagination(['search']),
    },
  },
  TrainingCourse: {
    fields: {
      sessionsConnection: relayStylePagination(),
    },
  },
  File: {
    fields: {
      signatures: { merge: overwriteMerge },
    },
  },
};
